import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import MenuHeader from './MenuHeader';
import { useTranslation } from 'react-i18next';
import { endpoints } from '../utils/utils';
import btnInfo from "../assets/images/icon-info.svg";
import useApi from '../hooks/useApi';
import Modal from 'react-modal';

// Modal styles
const customStyles = {
  content: {
    width: "33%",
    top: "50%",
    padding: "40px",
    left: "50%",
    right: "auto",
    bottom: "auto",
    borderRadius: "10px",
    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
    maxWidth: "450px",
    margin: "auto",
    textAlign: "center",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
  },
};

// Gray button CSS styles
const grayButtonStyle = {
  backgroundColor: '#808080',
  color: 'white',
  border: 'none',
  padding: '10px 20px',
  borderRadius: '5px',
  cursor: 'pointer',
  marginTop: '15px',
  fontSize: '16px',
  fontWeight: '500',
  width: '65%',
  transition: 'background-color 0.3s ease',
};

const Contact = () => {
  const { t } = useTranslation('contact');
  const navigate = useNavigate();

  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const axiosDefault = useApi();

  const openModal = () => {
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
    navigate('/choose-location');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const isEmailValid = email && /^\S+@\S+\.\S+$/.test(email);
    const isMessageValid = message.trim().length > 0;

    if (isEmailValid && isMessageValid) {
      const formData = {
        email,
        message
      };

      await axiosDefault.post(endpoints.contactPublic, formData);
      openModal();
    }
  };

  const handleRedirect = () => {
    closeModal();
  };

  return (
    <>
      <MenuHeader />

      <div className="container container-contact contact-page">
        <h2>{t('contact:call_us')}</h2>

        <form onSubmit={handleSubmit}>
          <div className="form-tel">
          <a href="tel:+41225483337">
            <input className="cursor-pointer" type="text" placeholder="+41 (0)22 548 33 37" readOnly />

            </a>
          </div>
          <div className="form-text">
            <label>{t('contact:email_address')}</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="form-textarea">
            <label>{t('contact:message')}</label>
            <textarea
              placeholder={t('contact:write_your_message')}
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              required
            ></textarea>
          </div>
          <div className="form-submit">
            <input type="submit" value={t('contact:send')} />
          </div>
        </form>
      </div>

      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Thank You Modal"
        ariaHideApp={false}
      >
        <div className="thank-you-modal-content">
          <button onClick={closeModal} className="close-btn">
            <img src={btnInfo} alt="Close" />
          </button>
          <p style={{ marginBottom: '20px' }}>{t('contact:thank_you_message')}</p>
          <button
            onClick={handleRedirect}
            style={grayButtonStyle}
            onMouseOver={(e) => e.target.style.backgroundColor = '#6e6e6e'}
            onMouseOut={(e) => e.target.style.backgroundColor = '#808080'}
          >
            {t('contact:services')}
          </button>
        </div>
      </Modal>
    </>
  );
};

export default Contact;
